module.exports = __webpack_public_path__ + "img/video-cover.29719ade.jpg";